<template>
  <div class="home">
    <h1>Dashboard</h1>
    <p>Applicazione per monitorare i prezzi dei concorrenti.</p>
    <router-link v-bind:to="{ name: 'Products' }" class="add_link">Prodotti</router-link>
    <br>
    <router-link v-bind:to="{ name: 'Websites' }" class="add_link">Siti</router-link>
    <br>
    <router-link v-bind:to="{ name: 'ReportProducts' }" class="add_link">Reports</router-link>

  </div>
</template>

<script>
export default {
  name: 'Dashboard',
  data () {
    return {
      msg: 'Benvenuto'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #4d7ef7;
  text-decoration: none;
}
a.add_link {
  background: #4d7ef7;
  color: #fff;
  padding: 10px 80px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
  margin-bottom: 20px;
  display: block;
  width: 320px;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue